import styled from '@emotion/styled';

export const StyledBackgroundLogo = styled.div`
  margin-left: 6px;
  cursor: pointer;
  img {
    height: 22px;
  }
`;
